import { ArrowRight, Filter, Search, Calendar, List, Grid, Plus } from "react-feather";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import styles from "../prospectListView.module.css";
import React, { useRef } from "react";
import FilterAutocomplete from "../../../../components/FilterAutocomplete";
import { CREDIT_OPTIONS, SALARY_OPTIONS, ProspectStatusAutocomplete, RangeFilterAutocomplete } from "../../Components/ProspectFilterFields";

const NOTES_OPTIONS = [
  { value: "all", label: "All" },
  { value: "notes", label: "Notes" },
];

const ListFilters = ({ setFilterData, setFilterOpen, filterOpen, filterData, propertyList, handleView, setCurrentFilterValue, setOpenAddProspectModal, setAddFormStep, isAuthenticated, setCreditFilterOpen, setAddCustomCredit, onSubmitCreditFiler, addCustomCredit, setCreditFilterDefaultOpen, creditFilterOpen, user, setSalaryFilterOpen, salaryFilterOpen, setAddCustomSalary, onSubmitSalaryFiler, addCustomSalary, setSalaryFilterDefaultOpen, setSearchKey, salaryFilterList, creditFilterList, delCustomFilter }) => {
  const searchTimeoutRef = useRef(null);

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => {
          const value = e.target.value;

          if (searchTimeoutRef.current)
            clearTimeout(searchTimeoutRef.current);

          searchTimeoutRef.current = setTimeout(() => {
            setSearchKey(value);
            setCurrentFilterValue("search");
          }, 1000);
        }} />
      </div>
      <div className={`${styles.ListGridBUCard} ${styles.Top}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("list")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>

      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:create") > -1 && (<button className={`${styles.AddNoteBu} ${styles.Top}`} onClick={(e) => { setOpenAddProspectModal(true); setAddFormStep(1); }}>
        <Plus /> <span>Prospect</span>
      </button>)}
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters{" "}
          <span onClick={(e) => setFilterOpen(false)}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter Autocomplete`}>
          <FilterAutocomplete
            label="Property"
            options={propertyList}
            value={filterData?.property}
            onChange={(value) => {
              setFilterData((prev) => {
                return { ...prev, property: value };
              });
              setCurrentFilterValue("property");
            }}
          />
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter Autocomplete`}>
          <ProspectStatusAutocomplete
            value={filterData.prospect}
            onChange={(value) => {
              setFilterData(prev => {
                return { ...prev, prospect: value };
              });
              setCurrentFilterValue("prospect");
            }}
          />
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              onChange={(date) => {
                setFilterData((prev) => {
                  return { ...prev, submitted_at: date };
                });
                setCurrentFilterValue("submitted_at");
              }}
            />
          </div>
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} CusSelectFilter Filter Autocomplete`}>
          <RangeFilterAutocomplete
            label="Filter by Credit"
            rangeType="credit"
            styles={styles}
            value={filterData?.credit || ""}
            options={CREDIT_OPTIONS.concat(creditFilterList || [])}
            open={creditFilterOpen}
            setOpen={setCreditFilterOpen}
            addCustom={addCustomCredit}
            setAddCustom={setAddCustomCredit}
            onSelect={(value) => {
              setFilterData((prev) => {
                return { ...prev, credit: value };
              });
              setCurrentFilterValue("credit");
              setCreditFilterDefaultOpen(true);
            }}
            onClear={() => {
              setFilterData((prev) => {
                return { ...prev, credit: "" };
              });
            }}
            onDelete={(value) => delCustomFilter(value, 'credit')}
            onApply={onSubmitCreditFiler}
            onCancel={() => { setAddCustomCredit(false); setFilterData((prev) => { return { ...prev, credit: "" }; }); setCreditFilterOpen(false); }}
          />
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width180} CusSelectFilter Filter Autocomplete`}>
          <RangeFilterAutocomplete
            label="Filter by Salary"
            rangeType="salary"
            styles={styles}
            value={filterData?.income || ""}
            options={SALARY_OPTIONS.concat(salaryFilterList || [])}
            open={salaryFilterOpen}
            setOpen={setSalaryFilterOpen}
            addCustom={addCustomSalary}
            setAddCustom={setAddCustomSalary}
            onSelect={(value) => {
              setFilterData((prev) => {
                return { ...prev, income: value };
              });
              setCurrentFilterValue("income");
              setSalaryFilterDefaultOpen(true);
            }}
            onClear={() => {
              setFilterData((prev) => {
                return { ...prev, income: "" };
              });
            }}
            onDelete={(value) => delCustomFilter(value, 'salary')}
            onApply={onSubmitSalaryFiler}
            onCancel={() => { setAddCustomSalary(false); setFilterData((prev) => { return { ...prev, income: "" }; }); setSalaryFilterOpen(false); }}
          />
        </div>

        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter Autocomplete`}>
          <FilterAutocomplete
            label="Follow-up Notes"
            options={NOTES_OPTIONS}
            value={filterData?.notes}
            onChange={(value) => {
              setFilterData((prev) => {
                return { ...prev, notes: value };
              });
              setCurrentFilterValue("notes");
            }}
          />
        </div>
      </div>
      <div className={`${styles.ListGridBUCard} ${styles.Bottom}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("list")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>

      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}><Filter /></Link>

      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:create") > -1 && (<button className={`${styles.AddNoteBu} ${styles.Bottom}`} onClick={(e) => { setOpenAddProspectModal(true); setAddFormStep(1); }}>
        <Plus /> <span>Prospect</span>
      </button>)}
    </div>
  </div>);
}

export default ListFilters;
